import { BaseBlok } from '@repo/roche-xx-shared';

export const isRichtextEmpty = (item: BaseBlok): boolean => {
  if (item.component !== 'roche-richtext') return true;

  const text = item.text as { content?: unknown } | undefined;
  const content = text?.content;

  if (!Array.isArray(content) || content.length === 0) return true;

  const hasContent = (nodes: unknown[]): boolean => {
    return nodes.some((node) => {
      if (typeof node !== 'object' || node === null) return false;

      const n = node as {
        text?: string;
        content?: unknown;
        type?: string;
        attrs?: { body?: unknown };
      };

      switch (n.type) {
        case 'blok':
          return n.attrs?.body && Array.isArray(n.attrs.body) && n.attrs.body.length > 0;

        case 'paragraph':
        case 'bullet_list':
        case 'ordered_list':
          if (Array.isArray(n.content)) {
            return hasContent(n.content);
          }
          return false;

        default:
          if (n.text && n.text.trim()) return true;

          if (Array.isArray(n.content)) {
            return hasContent(n.content);
          }

          return false;
      }
    });
  };

  return !hasContent(content);
};
